import * as mapboxgl from 'mapbox-gl';
import type { MapPointDraft, MapPointEditorResult } from './map-point.models';
import { createPointEditorForm } from './map-point-editor-form';

export function createPointPopup(
  map: mapboxgl.Map,
  draft: MapPointDraft,
  translate: (key: string) => string,
  finish: (result?: MapPointEditorResult) => void,
  detail?: HTMLElement | null
): mapboxgl.Popup {
  const form = createPointEditorForm(draft, translate, finish);
  if (detail) form.prepend(detail);
  return new mapboxgl.Popup({ closeButton: false, closeOnClick: false, offset: 16, maxWidth: '340px' })
    .setLngLat([draft.lng!, draft.lat!])
    .setDOMContent(form)
    .addTo(map);
}
